module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kmXy1"))).then(() => parcelRequire('9Lwss'));